<section class="ispm-card-holder ui-g">
  <div
    [ngClass]="widthCalculator(col.width,col?.styleClass)"
    *ngFor="let col of config.items;trackBy: trackByFunction">
    <gen-widget-item
      id = "id_{{widgetPayload?.name?.toLowerCase().split(' ').join('_')}}"
      *ngFor="let widgetPayload of col?.items"
      class="ui-g-12 ui-g-nopad"
      [ngStyle]="{height: widgetPayload.height}"
      [item] ="widgetPayload"
      [ngClass]="'ispm-pan-cancer-card ' + widgetPayload?.styleClass"
      [componentToLoad] ="widgetPayload?.componentToLoad">
    </gen-widget-item>
  </div>
</section>
